
import useLanguage from '../hooks/useLanguage';
import styles from '../assets/styles/FeatureSection.module.css';
import { translations } from '../locales/lang';

export default function FeatureSection() {
    const { language } = useLanguage();
    const features = [
        {
            icon: '/images/feature/icon-1.svg',
            title: translations[language].feature.features[0].title,
            desc: translations[language].feature.features[0].desc,
        },
        {
            icon: '/images/feature/icon-2.svg',
            title: translations[language].feature.features[1].title,
            desc: translations[language].feature.features[1].desc,
        },
        {
            icon: '/images/feature/icon-3.svg',
            title: translations[language].feature.features[2].title,
            desc: translations[language].feature.features[2].desc,
        },
        {
            icon: '/images/feature/icon-4.svg',
            title: translations[language].feature.features[3].title,
            desc: translations[language].feature.features[3].desc,
        },
        {
            icon: '/images/feature/icon-5.svg',
            title: translations[language].feature.features[4].title,
            desc: translations[language].feature.features[4].desc,
        },
        {
            icon: '/images/feature/icon-6.svg',
            title: translations[language].feature.features[5].title,
            desc: translations[language].feature.features[5].desc,
        },
    ];
    return (
        <section className={styles.section}>
            <h2 className={styles.heading}>{translations[language].feature.title}</h2>
            <div className={styles.grid}>
                {features.map((item, index) => (
                    <div key={index} className={styles.card}
                        data-aos={'fade'}
                        data-aos-delay={(index + 1) * 100}
                    >
                        <img src={item.icon} alt={item.title} className={styles.icon} />
                        <div className={styles.content}>
                            <div className={styles.title}>{item.title}</div>
                            <div className={styles.desc}>{item.desc}</div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
